import React from 'react'
import { node, string } from 'prop-types'
import { withStyles } from '@material-ui/styles'
import clsx from 'clsx'

const styles = (theme) => ({
	GradientWrapper: {
		background: `linear-gradient(180deg, ${theme.palette.tertiary.light} 0%, ${theme.palette.tertiary.main} 100%)`,
		display: 'flex',
		height: 'auto',
		width: '100%',
	},
})

/**
 * Gradient Container with a tertiary background
 * Wraps whatever elements in a gradient background with equal ammounts of padding top + bottom
 * @param {Object} props
 * @param {Node} props.children :: Contents that will be wrapped
 * @param {Object} props.classes :: list of classes
 * @param {String} props.variant :: light or dark
 */

export const GradientContainer = withStyles(styles, { name: 'gradientContainer' })(
	({ children, className, classes }) => {
		return <div className={clsx(classes.GradientWrapper, className)}>{children}</div>
	}
)

GradientContainer.propTypes = {
	children: node,
	variant: string,
}
